module.exports = __webpack_public_path__ + "static/media/Klavika-Medium.7a0149e0.woff";